module.exports = __webpack_public_path__ + "img/tree-07-c-trunk.1fa54c29.png";